/** Organisation seal — same image as the site's favicon (static/favicon.webp). */
export function Logo({
  size = 56,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <img
      src="/favicon.webp"
      width={size}
      height={size}
      alt="छत्रपती सेवा प्रतिष्ठान, नागपूर-पुणे बोधचिन्ह"
      className={`logo ${className}`}
    />
  );
}
